'use client';
import { BreadCrumbs, BreadCrumb } from '@picsart/design-system/components/BreadCrumbs';
import { Skeleton } from '@picsart/design-system/components/Skeleton';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';

import type { BreadcrumbListSegment } from '@/types/breadcrumb';
import { TEST_IDS } from './constants/testIds';
import BreadCrumbLink from './BreadCrumbLink';

interface BreadCrumpProps {
  segments: BreadcrumbListSegment[];
  className?: string;
}

const BreadCrump = ({ segments, className }: BreadCrumpProps) => (
  <BreadCrumbs className={className}>
    {segments.map(({ href, title, isSkeleton }, index) => {
      if (isSkeleton) {
        return (
          <BreadCrumb key={index} isActive data-testid={TEST_IDS.SKELETON}>
            <Skeleton width={80} height={16} borderRadius={CornerRadius.r4} dataTestId={TEST_IDS.SKELETON} />
          </BreadCrumb>
        );
      }

      if (index === segments.length - 1) {
        return (
          <BreadCrumb key={href} isActive data-testid={TEST_IDS.PAGE}>
            {title}
          </BreadCrumb>
        );
      }

      return (
        <BreadCrumbLink href={href} key={href} data-testid={TEST_IDS.LINK}>
          {title}
        </BreadCrumbLink>
      );
    })}
  </BreadCrumbs>
);

export default BreadCrump;
